export var Payment = {
  init: function(stripe_pk){
    var stripe = Stripe(stripe_pk);
    // Create an instance of Elements.
    var elements = stripe.elements();
    var isSubmiting = false;
    var enableSubmit = false;
    
    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: '#324961',
        fontFamily: '"Lato", sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: 'rgba(255,255,255,0)'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    // Create an instance of the card Element.
    var cardNumber = elements.create('cardNumber', {hidePostalCode: true, style: style});
    var cardExpiry = elements.create('cardExpiry', {hidePostalCode: true, style: style});
    var cardCvc = elements.create('cardCvc', {hidePostalCode: true, style: style});

    var fillCard = false;
    var fillExpiry = false;
    var fillCvc = false;
    // Add an instance of the card Element into the `card-element` <div>.
    cardNumber.mount('#card-number');
    cardCvc.mount('#card-cvc');
    cardExpiry.mount('#card-expiry');

    $("form").submit(function(e){
      if(enableSubmit){
        isSubmiting = true;
        enableSubmit = false;
        Payment.disabledSubmitBtn();
      }
    });

    // Create Setup Intent with payment method for 3DS authentication
    function createSetupIntentWithPaymentMethod(paymentMethodId) {
      return $.ajax({
        url: '/subscriptions/create_setup_intent',
        method: 'POST',
        dataType: 'json',
        data: {
          payment_method_id: paymentMethodId
        },
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      });
    }

    // Confirm SetupIntent completion for tracking
    function confirmSetupIntentCompletion(setupIntentId, stripeSetupIntentId) {
      return $.ajax({
        url: '/subscriptions/confirm_setup_intent_completion',
        method: 'POST',
        dataType: 'json',
        data: {
          setup_intent_id: setupIntentId,
          stripe_setup_intent_id: stripeSetupIntentId
        },
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      });
    }

    // Submit subscription with authenticated payment method
    function submitSubscription(paymentMethodId) {
      return $.ajax({
        url: '/subscriptions',
        method: 'POST',
        data: {
          payment_method_id: paymentMethodId,
          subscription_plan_id: $("input[name='subscription_plan_id[]']:checked").val(),
          coupon_code: $("input[name='coupon_code']").val(),
          subscription_type: $("input[name='subscription_type']").val()
        },
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      });
    }

    // Confirm payment intent for subscription 3DS (fallback - shouldn't be needed with new flow)
    function confirmPaymentIntent(paymentIntentId) {
      return $.ajax({
        url: '/subscriptions/confirm_payment_intent',
        method: 'POST',
        data: {
          payment_intent_id: paymentIntentId
        },
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      });
    }

    function handlePaymentMethodCreation(result) {
      var errorElement = $("#card-errors");
      errorElement.removeClass('visible');
      
      if (result.error) {
        errorElement.text(result.error.message);
        errorElement.addClass('visible');
        enableSubmit = false;
        isSubmiting = false;
        Payment.enableSubmitBtn();
        $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
      } else if (result.paymentMethod) {
        // Payment method created successfully, now create SetupIntent with 3DS authentication
        $("[data-target='pay-btn']").text('Authenticating payment...');
        
        createSetupIntentWithPaymentMethod(result.paymentMethod.id)
          .done(function(data) {
            if (data.requires_action && data.setup_intent_client_secret) {
              // SetupIntent requires 3DS authentication
              
              stripe.confirmCardSetup(data.setup_intent_client_secret)
                .then(function(result) {
                  if (result.error) {
                    errorElement.text(result.error.message);
                    errorElement.addClass('visible');
                    isSubmiting = false;
                    Payment.enableSubmitBtn();
                    $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
                  } else if (result.setupIntent.status === 'succeeded') {
                    // 3DS authentication successful, update tracking and create subscription
                    $("[data-target='pay-btn']").text('Creating subscription...');
                    
                    // Track SetupIntent completion
                    confirmSetupIntentCompletion(data.setup_intent_id, result.setupIntent.id)
                      .done(function(trackingData) {
                        // Proceed with subscription creation
                        submitSubscription(trackingData.payment_method_id || data.payment_method_id)
                          .done(function(subscriptionData) {
                            if (subscriptionData.success === true) {
                              // Subscription created successfully
                              window.location.href = subscriptionData.redirect_url || '/user/about-you';
                            } else if (subscriptionData.requires_action) {
                              // Fallback: subscription still requires action (shouldn't happen with new flow)
                              stripe.confirmCardPayment(subscriptionData.payment_intent_client_secret)
                                .then(function(result) {
                                  if (result.error) {
                                    errorElement.text(result.error.message);
                                    errorElement.addClass('visible');
                                    isSubmiting = false;
                                    Payment.enableSubmitBtn();
                                    $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
                                  } else if (result.paymentIntent.status === 'succeeded') {
                                    confirmPaymentIntent(result.paymentIntent.id)
                                      .done(function(confirmData) {
                                        if (confirmData.success) {
                                          window.location.href = '/user/about-you';
                                        } else {
                                          errorElement.text('Failed to complete subscription');
                                          errorElement.addClass('visible');
                                          isSubmiting = false;
                                          Payment.enableSubmitBtn();
                                          $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
                                        }
                                      });
                                  }
                                });
                            } else {
                              // Subscription failed
                              errorElement.text(subscriptionData.error || 'Failed to create subscription');
                              errorElement.addClass('visible');
                              isSubmiting = false;
                              Payment.enableSubmitBtn();
                              $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
                            }
                          })
                          .fail(function(xhr) {
                            var errorMessage = xhr.responseJSON && xhr.responseJSON.error ? 
                                              xhr.responseJSON.error : 
                                              'Failed to create subscription';
                            errorElement.text(errorMessage);
                            errorElement.addClass('visible');
                            isSubmiting = false;
                            Payment.enableSubmitBtn();
                            $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
                          });
                      })
                      .fail(function() {
                        // Tracking failed, but continue with subscription creation
                        submitSubscription(data.payment_method_id)
                          .done(function(subscriptionData) {
                            if (subscriptionData.success === true) {
                              window.location.href = subscriptionData.redirect_url || '/user/about-you';
                            } else {
                              errorElement.text(subscriptionData.error || 'Failed to create subscription');
                              errorElement.addClass('visible');
                              isSubmiting = false;
                              Payment.enableSubmitBtn();
                              $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
                            }
                          });
                      });
                  }
                });
            } else if (data.setup_intent_status === 'succeeded') {
              // SetupIntent succeeded without 3DS (regular card)
              $("[data-target='pay-btn']").text('Creating subscription...');
              
              // Track SetupIntent completion for non-3DS cards too
              confirmSetupIntentCompletion(data.setup_intent_id, data.gateway_uid)
                .always(function() {
                  // Proceed with subscription regardless of tracking success
                  submitSubscription(data.payment_method_id)
                    .done(function(subscriptionData) {
                      if (subscriptionData.success === true) {
                        window.location.href = subscriptionData.redirect_url || '/user/about-you';
                      } else {
                        errorElement.text(subscriptionData.error || 'Failed to create subscription');
                        errorElement.addClass('visible');
                        isSubmiting = false;
                        Payment.enableSubmitBtn();
                        $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
                      }
                    })
                    .fail(function(xhr) {
                      var errorMessage = xhr.responseJSON && xhr.responseJSON.error ? 
                                        xhr.responseJSON.error : 
                                        'Failed to create subscription';
                      errorElement.text(errorMessage);
                      errorElement.addClass('visible');
                      isSubmiting = false;
                      Payment.enableSubmitBtn();
                      $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
                    });
                });
            } else {
              // Unexpected SetupIntent status
              errorElement.text('Unexpected error during payment authentication');
              errorElement.addClass('visible');
              isSubmiting = false;
              Payment.enableSubmitBtn();
              $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
            }
          })
          .fail(function(xhr) {
            var errorMessage = xhr.responseJSON && xhr.responseJSON.error ? 
                              xhr.responseJSON.error : 
                              'An error occurred while processing your payment.';
            errorElement.text(errorMessage);
            errorElement.addClass('visible');
            isSubmiting = false;
            Payment.enableSubmitBtn();
            $("[data-target='pay-btn']").html('Next <i class="fal fa-arrow-right"></i>');
          });
      } else {
        errorElement.text("An unexpected error occurred.");
        errorElement.addClass('visible');
        enableSubmit = false;
        isSubmiting = false;
        Payment.enableSubmitBtn();
      }
    }

    cardNumber.on('change', function(event) {
      var errorElement = $("#card-errors");
      if (event.error) {
        errorElement.text(event.error.message);
        errorElement.addClass('visible');
      } else {
        errorElement.text("");
        errorElement.removeClass('visible');
      }
    });

    $("[data-target='pay-btn']").click(function(e){
      e.preventDefault();
      var products = $("input[name='subscription_plan_id[]']:checked").val();
      if ( !jQuery.isEmptyObject(products) ){
        isSubmiting = true;
        $("[data-target='pay-btn']").prop('disabled', true);
        $("[data-target='pay-btn']").text('Creating payment method...');
        
        // Create payment method first, then SetupIntent with 3DS authentication
        stripe.createPaymentMethod({
          type: 'card',
          card: cardNumber,
          billing_details: {
            email: $('input[name="user_email"]').val() || ''
          }
        }).then(handlePaymentMethodCreation);
      } else {
        const modal = new Foundation.Reveal($('#select_course_alert'))
        modal.open();
        $('[data-close]').on('click', function(){
          modal.close();
        })
      }
    });

    $("[data-target='change-btn']").click(function(e){
      e.preventDefault();
      $("[data-target='change-btn']").prop('disabled', true);
      if(fillCard||fillExpiry||fillCvc){
        // For change button, we might need to handle this differently
        // For now, just submit the form if all fields are filled
        $("form").submit();
      } else {
        $("form").submit();
      }
    });

    $("[data-target='pay-btn']").on('disabledSet', function(e){
      setTimeout(function(){
        if(!isSubmiting){
          Payment.enableSubmitBtn();
        }
      },0);
    });

    elements.getElement('cardNumber').on('change',function(e){
      if(e.empty){
        fillCard = false;
      }else{
        fillCard = true;
      }
    });

    elements.getElement('cardExpiry').on('change',function(e){
      if(e.empty){
        fillExpiry = false;
      }else{
        fillExpiry = true;
      }
    });

    elements.getElement('cardCvc').on('change',function(e){
      if(e.empty){
        fillCvc = false;
      }else{
        fillCvc = true;
      }
    });
  },

  enableSubmitBtn: function(){
    $("[data-target='pay-btn']").prop('disabled', false);
    $("[data-target='change-btn']").prop('disabled', false);
  },

  disabledSubmitBtn: function(){
    $("[data-target='pay-btn']").prop('disabled', true);
    $("[data-target='change-btn']").prop('disabled', true);
  }
};
